<template>
  <div class="container">
    <Container :active_path="'/reallyWillBuy/Leaseclass'" :plate="'项目巡览'">
      <div class="base-warp">
        <div class="head">
          <el-form ref="form" label-width="80px" :inline="true" size="normal">
           
            <el-form-item>
              <el-button type="primary" size="mini" @click="dialogVisible = true">添加办公分类</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-dialog v-bind="$attrs" v-on="$listeners" :visible.sync="dialogVisible" title="办公分类" width="30%">
            <el-row :gutter="15">
              <el-form ref="elForm" :model="formData" :rules="rules" size="small" label-width="100px"
                label-position="left">
                <el-col :span="15">
                  <el-form-item label="分类名称" prop="name">
                    <el-input v-model="formData.name" placeholder="请输入分类名称"  show-word-limit clearable
                      prefix-icon='el-icon-s-opportunity' :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="15">
                  <el-form-item label="分类介绍" prop="info">
                    <el-input v-model="formData.info" placeholder="请输入分类介绍"  show-word-limit clearable
                      :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="15">
                  <el-form-item label="分类排序">
                    <el-input type="number" v-model="formData.listorder" placeholder="分类排序"></el-input>
                    <div>排序值 越小越靠前</div>
                  </el-form-item>
                </el-col>
               
              </el-form>
            </el-row>
            <div slot="footer">
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="handleConfirm">确定</el-button>
            </div>
          </el-dialog>
        </div>
        <div class="table-box">
          <el-table :data="tabledata" border size="mini"
            :header-cell-style="{ background: '#f7f7f7', color: '#999', textAlign: 'center', fontWeight: 'normal' }">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="name" label="分类名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="info" label="分类介绍" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="listorder" label="排序" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="index" label="操作" width="210">
              <template slot-scope="s">
                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button>
                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                <el-button type="primary" size="mini" @click="edit(s.row)" plain>编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="page-tion" @current-change="currentChange" layout="prev, pager, next" :page-size="pagesize"
          :total="total" background>
        </el-pagination>
      </div>
    </Container>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import Container from "../../../components/container"

export default {
  components: {
    Container,
  },
  data () {
    return {
      path: '/reallyWillBuy/bookAnOrder',
      plate: '企业定制',
      search: {
        name: '',
      },
      dialogVisible: false,
      pageNo: 1,
      pagesize: 14,
      formData: {
        id: '',
        info: '',          //介绍
        name: '',             //项目名称
        listorder:''      //排序
      },
      rules: {
        name: [{
          required: true,
          message: '请输入该分类名称',
          trigger: 'blur'
        }],
        info: [{
          required: true,
          message: '请输入该分类介绍',
          trigger: 'blur'
        }],
      },
      tabledata: [],
      total: 0,
    }
  },
  mounted () {

    this.getTableData();
  },
  methods: {
    edit (row) {
      console.log(row);
      this.dialogVisible = true
      this.formData = row
    },
    close () {
      this.dialogVisible = false
    },
    handleConfirm () {
      this.$refs['elForm'].validate(valid => {
        if (valid) {
          console.log(this.formData, '8888');
          var params = {
            id: this.formData.id,
            name: this.formData.name,
            info: this.formData.info,
            listorder:this.formData.listorder
          }
          this.$api.addOfficeClassifications(params).then(res => {
            console.log(res, '=====');
            if (res === '添加成功' || res === '修改成功') {
              this.$message.success(res);
              this.dialogVisible = false
            }
            this.formData={}
            this.getTableData();

          })
        } else {
          this.$message.error('提交失败');
          this.dialogVisible = false
          return false;
        }
      })
    },
    confirm () {
      this.pageNo = 1;
      this.getTableData();
    },
    currentChange (page) {
      this.pageNo = page;
      this.getTableData();
    },
     //上下架
     putaway (row) {
      var params = {
        id: row.id,
        putaway: !row.putaway
      };
      this.$api.officeClassificationOnAndOffTheShelf(params).then((data) => {
        this.$message.success(data);
        this.getTableData();
      });
    },
    del (row) {
      this.$confirm("是否确定删除" + row.name).then(
        (confirm) => {
          var params = {
            id: row.id
          };
          this.$api.delOfficeClassifications(params).then((data) => {
            this.$message.success(data);
            this.getTableData();
          });
        },
        (cancel) => { }
      );
    },
    getTableData () {
      this.$api.officeClassification().then(data => {
        let { list, total } = data;
        this.tabledata = list;
        this.total = total;
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.el-rate {
  display: inline-block;
  vertical-align: text-top;
}

.el-upload__tip {
  line-height: 1.2;
}

.right-edit-box {
  position: absolute;
  right: 0;
  top: 0;
}

.el-carousel__item {
  background: #fff;
  border: 1px dashed #999;

  .img {
    width: 270px;
    height: 202px;
    vertical-align: middle;
    position: relative;
  }

  .name {
    position: absolute;
    color: #fff;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.4);
    bottom: 4px;
    left: 4px;
  }
}

.left-row {
  border: 1px dashed #d9d9d9
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  margin: 0 auto;
}
</style>